/**
 * "Próximos días" en Asistencia (008 · T097; contracts/ui.md §2.2, spec US6-4): bloque plegable,
 * **cerrado por defecto**, con el plan de los 7 días siguientes a hoy ("Sin horario asignado"
 * cuando no hay nada). `<details>`/`<summary>` nativos: accesibles con teclado y lector sin
 * JavaScript propio; el `summary` mide ≥ 44 px. Solo se monta si `has_schedule` (US6-6).
 */
import { ChevronDown } from 'lucide-react';

import type { StaffDaysResponse } from '@fermin/contracts';

import { t } from '../../i18n';

import { upcomingDaysOf } from './format';


export interface UpcomingDaysProps {
  data: StaffDaysResponse;
}

export function UpcomingDays({ data }: UpcomingDaysProps) {
  if (!data.has_schedule) return null;
  const days = upcomingDaysOf(data);
  return (
    <details
      data-testid="upcoming-days"
      className="group rounded-fm-lg border border-fm-border bg-fm-surface px-fm-4 shadow-fm-1"
    >
      <summary className="flex min-h-11 cursor-pointer list-none items-center justify-between gap-fm-2 py-fm-2 font-display text-fm-lg font-semibold text-fm-text [&::-webkit-details-marker]:hidden">
        <h2 className="font-display text-fm-lg font-semibold text-fm-text">
          {t('schedule.upcoming.title')}
        </h2>
        <ChevronDown
          aria-hidden="true"
          size={20}
          className="shrink-0 transition-transform duration-fm-fast group-open:rotate-180 motion-reduce:transition-none"
        />
      </summary>
      <ul className="flex flex-col divide-y divide-fm-border pb-fm-2">
        {days.map((day) => (
          <li
            key={day.day}
            data-testid="upcoming-day"
            data-day={day.day}
            className="flex flex-col gap-0.5 py-fm-2"
          >
            <span className="text-fm-sm text-fm-text-secondary">{day.label}</span>
            <span className="fm-tabular text-fm-base text-fm-text">{day.text}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
